import { fetch, SuccessResponse } from "./fetch";

export type ApplicationLogFeature =
  | "helm_app_user_bookings"
  | "helm_app_user_offer_creator"
  | "helm_app_user_payments"
  | "helm_app_user_yachts";

export type ApplicationLogKind = "event" | "error";

export type ApplicationLogMeta = Record<string, unknown>;

export type CreateApplicationLogInput = {
  eventType: string;
  feature?: ApplicationLogFeature;
  kind?: ApplicationLogKind;
  path?: string | null;
  offerId?: string | null;
  bookingId?: string | null;
  meta?: ApplicationLogMeta;
};

export type ApplicationLogResponse = {
  id: string;
  feature: ApplicationLogFeature;
  kind: ApplicationLogKind;
  eventType: string;
  path: string | null;
  timestamp: string;
  meta: ApplicationLogMeta;
};

export function createApplicationLog(input: CreateApplicationLogInput) {
  return fetch<SuccessResponse<ApplicationLogResponse>>("/api/actions", "POST", {
    feature: input.feature ?? "helm_app_user_offer_creator",
    kind: input.kind ?? "event",
    eventType: input.eventType,
    path: input.path ?? getCurrentPath(),
    offerId: input.offerId,
    bookingId: input.bookingId,
    meta: input.meta ?? {},
  });
}

function getCurrentPath() {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}
